import React from 'react';

import Typography from '@material-ui/core/Typography/Typography';
import { IBranch, PaymentProvider } from '../../../domain/entities/branch-entity';
import { EditPaymentFields } from './payment_fields_edit.component';
import { useStyles } from './payment_providers.styles';

export default function PaymentProvidersComponent({ branch }: { branch: IBranch }) {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
        <small>
          <b>Payment Provider</b>
        </small>
      </Typography>
      {(branch.payment_fields ?? [PaymentProvider.empty()]).map((provider) => (
        <EditPaymentFields
          key={provider.payment_provider ?? ''}
          branchId={branch.id}
          paymentProvider={provider}
        />
      ))}
    </div>
  );
}
